'use es6';

import { Record } from 'immutable';
export default class AdBasicRecord extends Record({
  adAccountId: null,
  adNetwork: null,
  id: null,
  name: null,
  campaignId: null,
  adGroupId: null
}) {
  get accountId() {
    return this.adAccountId;
  }

}